module.exports = __webpack_public_path__ + "LK.png?8205129cd2c042eacd50f7da1184fb63";